import { createAction } from 'redux-actions';
export const UPDATE_FLOW_USAGES = '@@lib/UPDATE_FLOW_USAGES';
export const UPDATE_FLOW_USAGES_PENDING = '@@lib/UPDATE_FLOW_USAGES_PENDING';
export const updateFlowUsages = createAction(UPDATE_FLOW_USAGES);
export const updateFlowUsagesPending = createAction(UPDATE_FLOW_USAGES_PENDING);
export const updateFlowUsagesAction = updatedFlowIds => dispatch => dispatch(updateFlowUsages(updatedFlowIds));
export const updateFlowUsagesPendingAction = () => dispatch => dispatch(updateFlowUsagesPending());